module.exports = __webpack_public_path__ + "static/media/vnda20.776811ee.png";